import GlobalChannelSettings from "./GlobalChannelSettings";
import { useContext, useCallback, useState, useEffect, useMemo } from "react";
import { DragInterfaceContext } from "./MouseDragProvider";

const RET_POS = [300, 650];

const CLOSE_BUTTON_COLOR = "rgb(224,96,85)";
const MINIMIZE_BUTTON_COLOR = "rgb(255,181,53)";

export default function GlobalChannelSettingsWindow({ initialPosition, onClose }) {

  const [pos, setPos] = useState(initialPosition||[RET_POS]);
  const dic = useContext(DragInterfaceContext);
  let { startDrag } = dic;

  const closeButtonDim = 12;

  let [transitionStyle, setTransitionStyle] = useState({});
  const [containerStyle, setContainerStyle] = useState({});

  function onClickClose() {
    let buttonRect = document.getElementsByClassName('adjust-channels-button')[0]?.getBoundingClientRect();
    let newPos = buttonRect != null ? [buttonRect.x, buttonRect.y] : RET_POS;
    const transitionTime = 200;
    setTransitionStyle({
      transition: `all ${transitionTime}ms`,
      transform: 'scale(0.02)',
      transformOrigin: 'top left',
    });
    setContainerStyle({
      //maxWidth: '40px'
      //transform: 'scale(0.05)',
    });
    setPos(newPos);
    setTimeout(() => {
      setTransitionStyle({});
      setContainerStyle({});
      onClose?.(false);
    }, transitionTime);
  }

  return (
    <div
      style={{
        position: "fixed",
        left: pos[0],
        top: pos[1],
        background: "#f0f0f0",
        borderBottomLeftRadius: 5,
        borderBottomRightRadius: 5,
        boxShadow:
          "0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12)",
        maxWidth: '500px',
        zIndex:9999999,
        ...transitionStyle,
      }}
    >
      <div style={{
        overflow: 'hidden',
        ...transitionStyle,
        ...containerStyle
      }}
      >
        <div
          class="rel"
          style={{
            background: "#ccc",
            //height:15,
            borderTopLeftRadius: 5,
            borderTopRightRadius: 5,
            borderBottom: "1px solid #aaa",
            padding: 3,
          }}
          onMouseDown={(e) => {
            let deltaX = e.clientX - pos[0];
            let deltaY = e.clientY - pos[1];

            startDrag({
              event: e,
              onMouseMove: (start, end, info) => {
                setPos([end[0] - deltaX, end[1] - deltaY]);
              },
              onDragEnd: (start, end, info) => {
                setPos([end[0] - deltaX, end[1] - deltaY]);
              },
            });
          }}
        >
          <div
            style={{
              textAlign: "center",
              fontSize: 12,
            }}
          >
            Channel Adjustment
          </div>

          <div
            style={{
              position: "absolute",
              top: "50%",
              transform: "translate(25%,-50%)",
              //left:'25%',
              height: closeButtonDim,
              width: closeButtonDim,
              overflow:'hidden',
              aspectRatio: "1 / 1",
              outline:'0.5px solid rgb(241,167,50)',
              padding: 3,
              borderRadius: "100%",
              background:MINIMIZE_BUTTON_COLOR, 
            }}
            onClick={onClickClose}
            class="sg-row h-center v-center h-center show-child-on-hover"
          >
            <div class="show-when-parent-hovered" style={{width:15,height:1.5,background:'rgb(147,77,16)'}}/>
          </div>
        </div>
        <GlobalChannelSettings />
      </div>
    </div>
  );
}
